// @mui material components
import { SignalWifiOff, Check, CloudOff } from "@mui/icons-material";
import Tooltip from "@mui/material/Tooltip";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import Constants from "utils/Constants";

function InvoicesStatusCell({ transmissionFailure }) {
  const good = (
    <SoftBox display="flex" alignItems="center">
      <SoftTypography variant="body1" color="success" sx={{ lineHeight: 0 }}>
        <Tooltip title={Constants.NO_TRANSMISSION_FAILURE_TEXT} placement="top">
          <Check />
        </Tooltip>
      </SoftTypography>
    </SoftBox>
  );

  const failureOne = (
    <SoftBox display="flex" alignItems="center">
      <SoftTypography variant="body1" color="error" sx={{ lineHeight: 0 }}>
        <Tooltip title={Constants.TRANSMISSION_FAILURE_1_TEXT} placement="top">
          <SignalWifiOff />
        </Tooltip>
      </SoftTypography>
    </SoftBox>
  );

  const failureTwo = (
    <SoftBox display="flex" alignItems="center">
      <SoftTypography variant="body1" color="warning" sx={{ lineHeight: 0 }}>
        <Tooltip title={Constants.TRANSMISSION_FAILURE_2_TEXT} placement="top">
          <CloudOff />
        </Tooltip>
      </SoftTypography>
    </SoftBox>
  );

  if (transmissionFailure === 1) return failureOne;
  if (transmissionFailure === 2) return failureTwo;
  return good;
}

export default InvoicesStatusCell;
